// @flow

import { buildRemarkText, buildRemarkTextWithDefaults } from './buildRemarkText';

export {
  buildRemarkTextWithDefaults,
};

export default buildRemarkText;
